import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchAbilities,
  createAbility,
  deleteAbility,   // 🆕
  Ability,
  AbilityIn,
} from '../api/rbacApi';

export function useAbilities() {
  const qc   = useQueryClient();

  /* list -------------------------------------------------- */
  const list = useQuery<Ability[], Error>({
    queryKey : ['rbac', 'abilities'],
    queryFn  : fetchAbilities,
    staleTime: 60_000,
  });

  /* add --------------------------------------------------- */
  const add = useMutation<Ability, Error, AbilityIn>({
    mutationFn : createAbility,
    onSuccess  : () =>
      qc.invalidateQueries({ queryKey: ['rbac', 'abilities'] }),
  });

  /* 🆕 remove --------------------------------------------- */
  const remove = useMutation<void, Error, string>({
    mutationFn : deleteAbility,
    onSuccess  : () =>
      qc.invalidateQueries({ queryKey: ['rbac', 'abilities'] }),
  });

  return { ...list, add, remove };   // 🆕 expose remove
}
